import XLSX from 'xlsx'

export default {
  data() {
    return {

      idInputDisable: false,
      nameInputDisable: false,
      keywordId: '',
      keywordType: '',
      keywordName: '',
      tableData: [],

      // 控制对话显示
      formLabelWidth: "120px",

      currentPage: 1,
      totalPage: 1,
      offset: '0',
      resourceLength: 30,

      action: this.baseUrl + 'file/upload_work?token=' + this.$store.state.authority_management,
      fileList: [],
      formLabelWidth: "120px",
      fileName: '',

      //修改图片名称的弹出框
      dialogUpdateVID: false,
      // VID号码
      VIDNum: '',
      //Vid号码对应的名称
      VIDName: '',
      //视频的id
      videoId: '',

      //增加图片名称的弹出框
      addDateVID: false,
      // 要增加的VID号码
      addVIDNum: '',
      //要增加的Vid号码对应的名称
      addVIDName: '',
      // 下载模板
      download: this.baseUrl + 'excel/batch_template_video.xlsx'
    }
  },
  methods: {
    //点击增加视频按钮弹窗
    addVideo() {
      this.addDateVID = true;
    },
    //点击编辑按钮的弹窗
    handleUpdate(obj) {
      this.VIDNum = obj.data;
      this.VIDName = obj.name;
      this.videoId = obj.id;
      this.dialogUpdateVID = true;
      // // console.log(obj);
      // obj.data
      // obj.id


      // this.dialogUpdateVID = true;
      // this.VIDNum = VID;
    },
    //确定编辑的
    confirmVideo() {
      //表单校验
      if (this.VIDName == '' || this.VIDNum == '') {
        this.$message({
          type: 'error',
          message: 'VID和视频名字都不能为空'
        });
        return false;
      }
      //发送修改请求
      let data = {
        token: this.$store.state.authority_management,
        name: this.VIDName,
        id: this.videoId,
        type: '1',
        data: this.VIDNum,
      };
      this.$post('resources/shop_edit', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            type: 'success',
            message: '修改成功！'
          });
          this.getData();
          this.videoId = '';
          this.dialogUpdateVID = false;
        } else {
          this.$message({
            type: 'error',
            message: '修改失败'
          });
        }
      })
    },
    //增加视频Vid确认按钮的表单校验
    addconfirmVideo() {

      if (this.addVIDName == '' || this.addVIDNum == '') {
        this.$message({
          type: 'error',
          message: 'VID和视频名字都不能为空'
        });
        return false;
      }
      //发送修改请求
      let data = {
        token: this.$store.state.authority_management,
        name: this.addVIDName,
        type: '1',
        data: this.addVIDNum,
        shop_id: this.$store.state.store.id
      };
      this.$post('resources/shop_create', data).then(res => {

        if (res.data.status == 'success') {
          this.$message({
            type: 'success',
            message: '添加成功！',

          });
          this.getData();
          this.videoId = '';
          this.addVIDNum = ''
          this.addVIDName = ''
          // this.addDateVID = false;
        } else {
          this.$message({
            type: 'error',
            message: '添加失败'
          });
        }
      })
    },
    //删除视频弹出选择是否删除
    handleDelete() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmDelete();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //确定删除视频
    confirmDelete() {
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
    },
    onSearch() {
      let offset = 0;
      let length = this.resourceLength
      let data = {
        token: this.$store.state.authority_management,
        id: this.keywordId,
        name: this.keywordName,
        offset: offset,
        length: length,
        type: 1
      };
      // 这里调用搜索资源接口
      this.$post('resources/shop_search', data).then(res => {
        this.tableData = res.data.result.data
        this.totalPage = res.data.result.total
		this.currentPage = 1
      })
    },
    oncli(dataa) {
      alert(dataa);
    },
    // onSubmit() {
    // 这里调用提交修改的接口
    // this.$post(url, data).then(res => {
    //   // console.log(res);
    // });
    // },
    onReset(formName) {
      // 这里是清空修改中的内容 不用管
      this.$refs[formName].resetFields();
    },
    hendelDelete(id) {
      alert(id);
      //调用删除接口
      let data = {
        token: this.$store.state.authority_management,
        id: id
      };
      this.$post('resources/delete', data).then(res => {
        // // console.log(res.data.status);
      });
    },
    handleModify(id) {
      // 调用编辑接口   
      // let offset = 0;
      // let length = 1
      // let data = { token: this.$store.state.id, id: id,offset:offset,length:length };
      // this.$post('resources/get', data).then(res => {
      //   // 将结果集历的东西赋值给data中的form 
      //     this.infoList = res.data.result
      //   // console.log(res);
      // });

    },
    onModify: function () {
      // let data = { token: this.$store.state.id, other: this.infoList };
      // this.$post(url, data).then(res => {
      //   // console.log(res);
      // });
    },
    onBack: function () { },
    handleSizeChange(val) {
      // // console.log(`每页 ${val} 条`);
      this.resourceLength = val;
    },
    handleCurrentChange(val) {
      // // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.offset = (val - 1) * this.resourceLength;
      this.getData();
    },

    handleRemove(file, fileList) {
      // // console.log(file, fileList);
    },
    handlePreview(file) {
      // // console.log(file);
    },
    handleSuccess(response, file, fileList) {
      // 上传成发生的事件
      // // console.log('文件上传成功');
      // // console.log(response.result);
      // // console.log(file);
      // // console.log(fileList);
      this.fileName = response.result
      if (response.status == 'success') {
        this.$post('resources/shop_create', {
          token: this.$store.state.authority_management,
          name: file.name,
          data: this.fileName,
          type: '5',
          shop_id: this.$store.state.store.id
        }).then(res => {
          // // console.log(res)
        })
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    getData() {
      let data = {
        token: this.$store.state.authority_management,
        type: 1,
        offset: this.offset,
        length: this.resourceLength,
        name: this.keywordName
      };
      this.$post('resources/shop_search', data).then(res => {
        // // console.log(res.data)
        this.tableData = res.data.result.data;
        // // console.log(this.tableData)
        this.totalPage = res.data.result.total;
        this.tableData.map((item) => {
          item.type = "视频类型"
        })
      })
    },

    // 批量上传视频资源
    upload(file, fileList) {
      let files = { 0: file.raw }
      this.readExcel(files);
    },

    // 读取表格
    readExcel(files) {
      var that = this;
      if (files.length <= 0) {//如果没有文件名
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$Message.error('上传格式不正确，请上传xls或者xlsx格式');
        return false;
      }

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表

          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容
          this.insert(ws)

          // that.peopleArr = [];//清空接收数据
          // if(that.peopleArr.length == 1 && that.peopleArr[0].roleName == "" && that.peopleArr[0].enLine == ""){
          //     that.peopleArr = [];
          // }
          //重写数据
          // try {

          // } catch (err) {
          //   console.log(err)
          // }

          this.$refs.upload.value = '';

        } catch (e) {
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
    },

    // 发送请求插入视频资源
    insert(list) {
      list.map(item => {
        this.$post('resources/shop_create', {
          token: this.$store.state.authority_management,
          shop_id: this.$store.state.store.id,
          name: item.name,
          data: item.vid,
          type: 1
        }).then(res => {
          this.$message({
            message: "新增视频资源成功!",
            type: "success"
          })
        })
      })
    }

  },
  created() {
    // 获取数据
    this.getData();
    this.$post("md5/get")
      .then(res => {
        // // console.log(res.data.result);
        return res.data.result;
      })
      .then(data => {
        var obj = {
          uploadButtton: "upload",
          userid: data.userid,
          ts: data.ts,
          hash: data.hash,
          sign: data.sign,
          component: "all",
          cataid: 1,
          luping: 1,
          extra: {
            keepsource: 1
          }
        };
        let upload = new PolyvUpload(obj);
      });

  }
}
